// export const API_URL = 'http://plexidoc.viaweb.com.ua/wp-json/plexidoc/v1';

export const API_URL = '/wp-json/plexidoc/v1';
// export const API_URL = 'http://wp.loc/wp-json/plexidoc/v1';


// export const AUTH_TOKEN = 'Bearer 7b523eeacfc99bae7d01ff19eaf96aea';
// export const AUTH_TOKEN = 'Bearer 68258dfa20b4794eb0aca9b5071cf404';
// export const API_URL = 'http://plxd.loc/api';
